import { c as _c } from "react/compiler-runtime";
import { SvgIcon, SvgIconProps } from '@mui/material';
const CCSAIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M7.818 0.094c-4.263 0.108-7.692 3.604-7.692 7.893 0 4.357 3.536 7.893 7.893 7.893s7.893-3.536 7.893-7.893c0-4.357-3.536-7.893-7.893-7.893-0.068 0-0.133-0.002-0.2 0zM7.81 1.451c0.070-0.002 0.138 0 0.208 0 3.608 0 6.536 2.928 6.536 6.536s-2.928 6.536-6.536 6.536c-3.608 0-6.536-2.928-6.536-6.536-0-3.537 2.817-6.425 6.328-6.536zM4.594 6.701h-0.676l1.534 1.719 1.534-1.719h-0.553c0.12-0.839 0.857-1.378 1.71-1.31 0.034 0.002 0.066 0 0.1 0 1.388 0 1.935 1.050 1.981 2.597 0.047 1.615-0.889 2.619-1.981 2.597-1.153-0.023-1.589-0.574-1.757-1.41h-2.058c0.339 1.926 1.757 3.056 3.769 3.060 2.278 0.004 3.923-1.902 3.923-4.247 0-2.505-1.645-4.247-3.923-4.247-0.068 0-0.133-0.004-0.2 0-0.016 0.001-0.030-0.001-0.046 0-1.423 0.024-3.355 1.021-3.355 2.96z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon viewBox="0 0 16 16" {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CCSAIcon;